import { createSelector } from 'reselect'

const mapForDropdown = ({ countries = [], regionId }) => {
  return countries
    .filter(country => country.region.id === regionId)
    .map(country => ({
      value: country.id,
      label: country.name
    }))
}

export default createSelector(
  (countries, regionId) => ({
    countries,
    regionId
  }),
  mapForDropdown
)
